import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NumberService } from '../../shared/services/number.service';
import { ProviderCodeService } from '../../shared/services/provider-code.service';
import { DatePipe } from '@angular/common';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';
import { ChatModalComponent } from '../../shared/chat-modal/chat-modal.component';

@Component({
  selector: 'app-archive',
  standalone: true,
  imports: [FormsModule, DatePipe, LeftSidebarComponent, ChatModalComponent],
  templateUrl: 'archive.component.html',
})
export class ArchiveComponent implements OnInit {
  private numberService = inject(NumberService);
  private providerCodeService = inject(ProviderCodeService);
  numbers = signal<any[]>([]);
  providerCodes: { id: number; prefix_code: string; code: string }[] = [];
  selectedProviderCodeId: number | null = null;
  search: string = '';
  fromDate: Date | undefined;
  untilDate: Date | undefined;
  selectedNumber = signal<any | null>(null);

  ngOnInit() {
    this.loadNumbers();
    this.loadProviderCodes();
  }

  loadNumbers() {
    this.numberService
      .getNumbers(
        this.search,
        this.selectedProviderCodeId,
        this.fromDate ? this.fromDate.toString() : '',
        this.untilDate ? this.untilDate.toString() : '',
      )
      .subscribe({
        next: (data) => this.numbers.set(data.numbers),
        error: (err) => console.error(err),
      });
  }

  loadProviderCodes() {
    this.providerCodeService.getProviderCodes().subscribe({
      next: (data) => (this.providerCodes = data.provider_codes),
      error: (err) => console.error(err),
    });
  }

  openChat(number: any) {
    this.selectedNumber.set(number);
  }

  closeChat() {
    this.selectedNumber.set(null);
  }

  onPinged(pingedAt: string) {
    const current = this.selectedNumber();
    if (!current) {
      return;
    }
    this.numbers.update((numbers) =>
      numbers.map((number) =>
        number.number_id === current.number_id && number.provider_code_id === current.provider_code_id
          ? { ...number, pinged_at: pingedAt }
          : number,
      ),
    );
    this.selectedNumber.update((number) => (number ? { ...number, pinged_at: pingedAt } : number));
  }
}
